<ng-template #placeSidebarTemplate>
    <div>
        <ig-row class="top-bar">
            <ig-col [xs]="5">
                <span>PLACES</span>
            </ig-col>
            <ig-col [xs]="6">
                <ig-button (trigger)="back()">BACK</ig-button>
            </ig-col>
        </ig-row>
    </div>

    <div class="scrolling-wrap" [ngClass]="{'map-view-whole-list-height':showingCount}">
        <ig-custom-default-place-category-accordion *ngIf="customDefaultPlaceCategory"
            id="place-map-custom-default-category" #customDefaultPlaceAccordion [selectedCategory]="category"
            [toggleAndSource]="toggleAndSource"
            (onCategoryClick)="selectCustomDefaultPlaceCategory($event);customPlaceBtn&&customPlaceBtn.clearFilter()"
            (onNormalCategoryClick)="filterPlace($event);customPlaceBtn&&customPlaceBtn.clearFilter()"
            [customDefaultPlaceCategory]="customDefaultPlaceCategory"></ig-custom-default-place-category-accordion>

        <ig-custom-place-btn #customPlaceBtn mode="sidebar"
            (onCustomPlaceSelected)="customPlaceBtnSelected($event)"></ig-custom-place-btn>

        <div class="map-view-whole-list hidden-on-mobile">
            <div *ngIf="(!places||!places.length)&&!isLoading" class="no-content">No Content Here</div>
            <div class="map-view-list-wrap" *ngFor="let place of places; let i = index"
                (mouseenter)="showInfoWindowByIndex(i)" (click)="gotoDetails(place._id)"
                matTooltip="Click to See Details">
                <ig-row>
                    <ig-col [xs]="8">
                        <div class="map-view-list-title">{{place.name || place.title}}</div>
                        <div class="map-view-list-info">
                            <ig-row>
                                <ig-col [xs]="1">
                                    <mat-icon>room</mat-icon>
                                </ig-col>
                                <ig-col [xs]="11">{{place.address.address || '(no location)'}}</ig-col>
                            </ig-row>
                        </div>
                        <div class="map-view-list-info">
                            <ig-row>
                                <ig-col [xs]="1">
                                    <mat-icon>list</mat-icon>
                                </ig-col>
                                <ig-col [xs]="11">{{place.categoryText || place.category}}</ig-col>
                            </ig-row>
                        </div>
                    </ig-col>
                    <ig-col [xs]="4" class="map-view-list-img-warp relative">
                        <ig-image class="map-view-list-img" [imageUrl]="place.cover?.source"
                            [placeCategoryList]="place.categoryList" alt="place image"></ig-image>
                        <div class="choice-label" *ngIf="place.isChoice">
                            <mat-icon>favorite</mat-icon>
                        </div>
                    </ig-col>
                </ig-row>
            </div>
        </div>
    </div>

    <div *ngIf="showingCount" class="results map-view-list-info hidden-on-mobile"
        [ngClass]="{'result-height':showingCount}">
        Showing results {{showingCount}} <span [ngClass]="{'no-more':noMoreBack}"
            (click)="pagingBack()"><mat-icon>chevron_left</mat-icon></span>
        <span [ngClass]="{'no-more':noMoreNext}" (click)="pagingNext()"><mat-icon>chevron_right</mat-icon></span>
    </div>
</ng-template>

<div class="event-map" *ngIf="!isInitLoading">
    <ig-row class="full-height">
        <ig-col [xs]="12">
            <mat-sidenav-container class="full-height">
                <mat-sidenav #sideBar mode="over" [opened]="isSideBarOpened">
                    <!--<ig-side-bar (onClose)="sideBar.close()"></ig-side-bar>-->
                    <button mat-icon-button class="go-back" (click)="sideBar.close()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <ng-container [ngTemplateOutlet]="placeSidebarTemplate"></ng-container>
                </mat-sidenav>
                <mat-sidenav-content class="full-height">
                    <div class="page-header">
                        <button mat-icon-button (click)="sideBar.open()">
                            <mat-icon>menu</mat-icon>
                        </button>
                        <h1>Places</h1>
                    </div>
                    <div class="full-height">
                        <ig-row class="full-height">
                            <ig-col class="stick-side-bar" [xs]="3">
                                <ng-container [ngTemplateOutlet]="placeSidebarTemplate"></ng-container>
                            </ig-col>
                            <ig-col class="content" [xs]="9">
                                <ig-button *ngIf="isMobile" size="md" (trigger)="back()">BACK</ig-button>
                                <agm-map #map [styles]="hideIconMapStyler"
                                    [ngClass]="{'full-map':isMapFullSize,'half-map':!isMapFullSize}"
                                    [fitBounds]="latLngBounds" [latitude]="lat" [longitude]="lng"
                                    (zoomChange)="mapZoomChange()">
                                    <!--[iconUrl]="imageService.imageSourceUrl(placeMapIcon[geo.mapIcon])""-->
                                    <agm-marker *ngFor="let geo of places; let i = index" [latitude]="geo.lat"
                                        [longitude]="geo.lng" (mouseOver)="showInfoWindowOnMarker(i)">
                                        <agm-snazzy-info-window [isOpen]="isInfoWindowsOpen[i]"
                                            [closeWhenOthersOpen]="true" (afterClose)="hideAllSingleInfoWindow()">
                                            <ng-template>
                                                <div style="position: relative" (mouseenter)="removeDisplayInfoWindow()"
                                                    (mouseleave)="addDisplayInfoWindow()">
                                                    <div class="map-event-title">
                                                        {{geo.title}}
                                                    </div>
                                                    <div class="map-event-img">
                                                        <ig-image class="map-event-img" [imageUrl]="geo.cover?.source"
                                                            [placeCategoryList]="geo.categoryList"
                                                            alt="place"></ig-image>
                                                    </div>
                                                    <div class="map-event-time">
                                                        {{geo.address.address}}
                                                    </div>
                                                    <ig-button class="event-btn" (trigger)="gotoDetails(geo._id)">
                                                        DETAILS
                                                    </ig-button>
                                                </div>
                                            </ng-template>
                                        </agm-snazzy-info-window>
                                    </agm-marker>

                                    <agm-snazzy-info-window #infoWindow [latitude]="groupLat" [longitude]="groupLng"
                                        [isOpen]="showGroupInfowWindow" [closeWhenOthersOpen]="true"
                                        (afterClose)="groupInfoWindowCloses()">
                                        <ng-template>
                                            <div style="position: relative" (mouseenter)="removeDisplayInfoWindow()"
                                                (mouseleave)="addDisplayInfoWindow()">
                                                <div class="map-view-group-wrap map-view-list-wrap"
                                                    *ngFor="let e of groupPlaces" (click)="gotoDetails(e._id)"
                                                    matTooltip="Click to See Details">
                                                    <ig-row>
                                                        <ig-col [xs]="8">
                                                            <div class="map-view-list-title">{{e.title||e.name}}</div>
                                                            <div class="map-view-list-info">
                                                                <ig-row>
                                                                    <ig-col [xs]="1">
                                                                        <mat-icon>room</mat-icon>
                                                                    </ig-col>
                                                                    <ig-col [xs]="11">
                                                                        {{e.address.address}}
                                                                    </ig-col>
                                                                </ig-row>
                                                            </div>
                                                        </ig-col>
                                                        <ig-col [xs]="4" class="map-view-list-img-warp">
                                                            <ig-image class="map-view-list-img"
                                                                [imageUrl]="e.cover?.source"
                                                                [placeCategoryList]="e.categoryList"
                                                                alt="place image"></ig-image>
                                                        </ig-col>
                                                    </ig-row>
                                                </div>
                                            </div>

                                        </ng-template>
                                    </agm-snazzy-info-window>

                                </agm-map>

                                <div class="expand-map" (click)="resizeMap()">
                                    <mat-icon *ngIf="!isMapFullSize">fullscreen</mat-icon>
                                    <mat-icon *ngIf="isMapFullSize">fullscreen_exit</mat-icon>
                                </div>

                                <div class="scrolling-wrap" [ngClass]="{'map-view-mobile':showingCount}">

                                    <div class="map-view-whole-list">
                                        <div *ngIf="(!places||!places.length)&&!isLoading" class="no-content">No Content
                                            Here
                                        </div>
                                        <div class="map-view-list-wrap" *ngFor="let place of places; let i = index"
                                            (mouseenter)="showInfoWindowByIndex(i)" (click)="gotoDetails(place._id)"
                                            matTooltip="Click to See Details.">
                                            <ig-row>
                                                <ig-col [xs]="8">
                                                    <div class="map-view-list-title">{{place.title||place.name}}</div>
                                                    <div class="map-view-list-info">
                                                        <ig-row>
                                                            <ig-col [xs]="1">
                                                                <mat-icon>room</mat-icon>
                                                            </ig-col>
                                                            <ig-col [xs]="11">{{place.address.address || '(no
                                                                location)'}}
                                                            </ig-col>
                                                        </ig-row>
                                                    </div>
                                                    <div class="map-view-list-info">
                                                        <ig-row>
                                                            <ig-col [xs]="1">
                                                                <mat-icon>list</mat-icon>
                                                            </ig-col>
                                                            <ig-col [xs]="11">{{place.categoryText}}
                                                            </ig-col>
                                                        </ig-row>
                                                        <ig-row>
                                                            <ig-col [xs]="1">
                                                                <mat-icon>thumb_up</mat-icon>
                                                            </ig-col>
                                                            <ig-col [xs]="11">Rating {{place.rating}}
                                                            </ig-col>
                                                        </ig-row>
                                                    </div>
                                                </ig-col>
                                                <ig-col [xs]="4" class="map-view-list-img-warp">
                                                    <ig-image class="map-view-list-img" [imageUrl]="place.cover?.source"
                                                        [placeCategoryList]="place.categoryList"
                                                        alt="place image"></ig-image>
                                                </ig-col>
                                            </ig-row>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="showingCount" class="results map-view-list-info"
                                    [ngClass]="{'result-height':showingCount}">
                                    Showing results {{showingCount}} <span [ngClass]="{'no-more':noMoreBack}"
                                        (click)="pagingBack()"><mat-icon>chevron_left</mat-icon></span>
                                    <span [ngClass]="{'no-more':noMoreNext}"
                                        (click)="pagingNext()"><mat-icon>chevron_right</mat-icon></span>
                                </div>
                            </ig-col>
                        </ig-row>
                    </div>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </ig-col>
    </ig-row>
</div>

<ig-page-spinner #spinner></ig-page-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.map/visitor.place.map.component.html